import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.scss";

const NotificationNavList = ({ categories }) => {
  const [activeSection, setActiveSection] = useState(categories[0]?.id);
  const navRef = useRef(null);
  const observerRef = useRef(null);

  const categoriesList = categories.map((category) => ({
    id: category.id,
    name: category.name,
  }));

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const categoryId = entry.target.dataset.categoryId;
            setActiveSection(categoryId);
          }
        });
      },
      {
        rootMargin: "-25% 0% -75% 0%",
        threshold: 0,
      },
    );

    categoriesList.forEach((category) => {
      const element = document.getElementById(category.id);
      if (!element) return;

      element.dataset.categoryId = category.id;
      observerRef.current.observe(element);
    });

    return () => {
      observerRef?.current?.disconnect();
    };
  }, []);

  const handleNavClick = (category) => {
    const element = document.getElementById(category?.id);

    if (!element) return;

    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  };

  return (
    <ul className={styles.navList} ref={navRef}>
      {categoriesList.map((cat) => (
        <li
          key={`category-list-item-${cat.id}`}
          className={activeSection === cat.id ? styles.active : ""}
          onClick={() => handleNavClick(cat)}
        >
          {cat.name}
        </li>
      ))}
    </ul>
  );
};

export default NotificationNavList;
